import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getTeams, setSelectedTeamId} from '../../../stores/teams'
import {getServices} from '../../../stores/resources'
import {HelpIcon} from '../../../icons'
import Badge from '../../core/badge'
import CustomSelect from '../../core/customSelect'
import Tooltip from '../../core/tooltip'
import {getActiveMembers} from '../../../stores/members'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const TeamSwitcher = ({onChange, isDisabled, isInfoDisabled, containerClassName}) => {
    const teams = useSelector(state => state.teams.teams)
    const text = useNamespaceTranslations('teams')
    const teamId = useSelector(state => state.teams.selectedTeamId)
    const localTeams = teams?.map(item => {
        return {
            ...item,
            disabled: isDisabled && teamId !== item.value,
            label: <span className="d-flex justify-content-between align-items-center gap-half">
                {item.label}
                {item?.is_member && <Badge color="success">Current</Badge>}
            </span>
        }
    })

    const team = teams.find(item => item.value === teamId)
    const dispatch = useDispatch()

    const fetchMembers = async() => {
        await dispatch(getActiveMembers(teamId))
    }

    useEffect(() => {
        dispatch(getTeams())

        if (teamId) {
            fetchMembers()
        }
    }, [teamId])

    useEffect(() => {
        if (teams.length && isDisabled) {
            dispatch(setSelectedTeamId(teams.find(item => item?.is_member)?.team_id))
        }
    }, [teams])

    return team && (
        <div className="data-switcher-container">
            <CustomSelect
                placeholder={text.team}
                containerClassName={containerClassName || 'w-auto'}
                options={localTeams}
                name="team_id" value={team}
                onChange={(name, data) => {
                    dispatch(setSelectedTeamId(data.value))
                    dispatch(getServices())
                    onChange && onChange()
                }}/>
            {!isInfoDisabled &&
            <Tooltip placement="right" interactive trigger="click"
                content={text.info_text}>
                <HelpIcon/>
            </Tooltip>}
        </div>
    )
}

export default TeamSwitcher
